import amplitude from 'amplitude-js';
var seGroupAmplitude = function (masterToken) {
    amplitude.getInstance().setGroup('TVINGORG', masterToken);
};
export default seGroupAmplitude;
